import { type ExpandedFieldStateManager } from "./ExpandedFieldStateManager";
import { typeInfoFor } from "./TypeTagInfo";
import { type ValueInspectorRowInfo } from "./ValueInspectorRowInfo";
import { type ValuePath, concatPath } from "./ValuePath";
import { traverseObjectValue } from "./traverseObjectValue";
import { traverseValue } from "./traverseValue";

export function traverseMapValue(
	fieldExpander: ExpandedFieldStateManager,
	pathToM: ValuePath,
	m: Map<never, unknown>,
	shallow: boolean
) {
	const fields: ValueInspectorRowInfo[] = [];
	for (const [key, value] of m) {
		const typeInfo = typeInfoFor(value);
		const newPath = concatPath(pathToM, { type: "MapField", key, value, typeInfo });
		fields.push(...traverseValue(fieldExpander, newPath, typeInfo, shallow));
	}

	return fields.concat(traverseObjectValue(fieldExpander, pathToM, m, shallow));
}
